import { render, staticRenderFns } from "./MenuSettingTree.vue?vue&type=template&id=45115ac6&scoped=true"
import script from "./MenuSettingTree.vue?vue&type=script&lang=js"
export * from "./MenuSettingTree.vue?vue&type=script&lang=js"
import style0 from "./MenuSettingTree.vue?vue&type=style&index=0&id=45115ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45115ac6",
  null
  
)

export default component.exports